import { IconButton } from "@material-ui/core";
import React from "react";
import { CloseIcon } from "../../assets";

const CustomCloseModalButton = ({toggle}) => (
  <IconButton onClick={toggle}>
    <CloseIcon />
  </IconButton>
);

export default CustomCloseModalButton;



// WEBPACK FOOTER //
// ./src/components/common/CustomCloseModalButton.jsx